import { ActionIcon } from "@mantine/core";
import { IconPlayerPlay, IconX } from "@tabler/icons-react";
import type { ReactNode } from "react";

import { PlaybackControlVariant } from "./playback-control-variant";
import type { StaticTextTranslator } from "../../../utils";

import styles from "./Playback.module.css";

interface ControlProps {
  className?: string;
  isLoading: boolean;
  onClick: () => void;
  translate: StaticTextTranslator;
  variant: PlaybackControlVariant;
}

interface VariantDetails {
  className: string;
  icon: ReactNode;
  label: string;
}

const joinClasses = (...classes: (string | undefined | false)[]) =>
  classes.filter(Boolean).join(" ");

export const PlaybackControl = ({
  className: classNameOverride,
  isLoading,
  onClick,
  translate,
  variant,
}: ControlProps) => {
  let variantDetails: VariantDetails;

  switch (variant) {
    case PlaybackControlVariant.Delete:
      variantDetails = {
        className: joinClasses(styles.delete, classNameOverride),
        icon: <IconX size={20} />,
        label: translate("Delete"),
      };
      break;
    case PlaybackControlVariant.Play:
      variantDetails = {
        className: joinClasses(styles.play, classNameOverride),
        icon: <IconPlayerPlay size={20} />,
        label: translate("Play"),
      };
      break;
    case PlaybackControlVariant.Stop:
      variantDetails = {
        className: joinClasses(styles.stop, classNameOverride),
        icon: <div className={styles.stopSquare} />,
        label: translate("Stop"),
      };
      break;
  }

  const { className, icon, label } = variantDetails;

  return (
    <ActionIcon
      aria-label={label}
      className={joinClasses(className, styles.control)}
      loading={isLoading}
      onClick={onClick}
      variant="subtle"
    >
      {icon}
    </ActionIcon>
  );
};
